import {alpha, createTheme} from "@mui/material/styles";

const headerFontFamily = "'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\n" +
    "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
    "    sans-serif";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#fff',
        },
        secondary: {
            main: '#070607',
        },
        tertiary: {
            light: '#FFE34D',
            main: '#FFD700',
            dark: '#CCAC00',
        },
        quaternary: {
            light: '#7C29C0',
            main: '#541C82',
            dark: '#2B0E43',
        }
    },
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\n" +
            "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
            "    sans-serif",
        h1: {
            fontFamily: headerFontFamily,
        },
        h2: {
            fontFamily: headerFontFamily,
        },
        h3: {
            fontFamily: headerFontFamily,
        },
        h4: {
            fontFamily: headerFontFamily,
        },
        h5: {
            fontFamily: headerFontFamily,
        },
        h6: {
            fontFamily: headerFontFamily,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        input:-webkit-autofill {
          -webkit-text-fill-color: black;
        }
      `,
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                containedPrimary: ({theme}) => ({
                    "&:disabled": {
                        color: alpha(theme.palette.primary.main, .2),
                        backgroundColor: alpha(theme.palette.primary.main, .12),
                    },
                }),
                root: {
                    textTransform: 'initial',
                    borderRadius: 20,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: ({theme}) => ({
                    color: theme.palette.primary.main,
                }),
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: ({theme}) => ({
                    "&:disabled": {
                        color: alpha(theme.palette.primary.main, .5),
                    },
                }),
            },
        },
        MuiTab: {
            styleOverrides: {
                textColorPrimary: ({theme}) => ({
                    "&:not(.Mui-selected)": {
                        color: alpha(theme.palette.primary.main, .5),
                    },
                }),
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    minWidth: '10em',
                },
            },
        },
        MuiSkeleton: {
            styleOverrides: {
                root: ({theme}) => ({
                    background: alpha(theme.palette.primary.main, .5),
                }),
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: ({theme}) => ({
                    backgroundColor: alpha(theme.palette.secondary.main, .1),
                }),
            },
        },
        MuiInputLabel: {
            defaultProps: {color: 'secondary'}, // use dark color by default
            styleOverrides: {
                root: ({theme}) => ({
                    color: alpha(theme.palette.secondary.main, .8),
                    '&.Mui-focused, &.MuiFormLabel-filled, &.MuiInputLabel-shrink': {
                        color: theme.palette.secondary.main, // prevent turning white
                    },
                    '&.Mui-error': {color: theme.palette.error.main},
                    '&.Mui-disabled': {color: alpha(theme.palette.secondary.main, .5)},
                }),
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: ({theme}) => ({
                    color: alpha(theme.palette.secondary.main, .8),
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                        color: theme.palette.secondary.main,
                    },
                    '&.Mui-error': {color: theme.palette.error.main},
                    '&.Mui-disabled': {color: alpha(theme.palette.secondary.main, .5)},
                }),
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: ({theme}) => ({
                    // When hovering or focused (active option)
                    '&:hover, &.Mui-focusVisible': {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.12), // active/hover background
                    },

                    // When selected (the chosen value)
                    '&.Mui-selected': {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.18),
                        '&:hover, &.Mui-focusVisible': {
                            backgroundColor: alpha(theme.palette.secondary.main, 0.25), // darker when hovered
                        },
                    },
                }),
            },
        },
    },
});
